import React, { Component } from "react"
import { Link } from "react-router-dom"
import { Button } from "semantic-ui-react"
import "pages/Login.css"

import shop from "shop/shop"

class LogoutPage extends Component {
  constructor() {
    super()
    this.state = {
      user:     "",
      password: ""
    }
    shop.logout()
      .then( shop.whoami )
      .then( () => {
        document.location.replace( "/" )
      } )
  }

  render() {
    // browserHistory.push("/login") => Let whoami + custom logic handle the redirecting
    return (
      <div className="container flex vh-100 items-center justify-center">
        <div>
          <h2 className="animate fadeInDown">{translate("Sie sind abgemeldet")}</h2>
          <ul className="mw6">
            {/*<li><Button fluid as={"a"} href="http://scantex.de"> Zu unserer Webseite </Button></li>*/}
            <li className="pt2">
              <Button fluid as={Link} to="/login">Zurück zum Shop</Button></li>
          </ul>
        </div>
      </div>
    )
  }
}

export default LogoutPage



// WEBPACK FOOTER //
// ./src/theme/base/pages/LogoutPage.js